import { Action } from "common/types/redux";

import { AssignmentsFilter } from "../../../../state/models/ParentUiState";
import actionTypes from "../action-types";

export default function assignmentsFilterReducer(
  state: AssignmentsFilter = AssignmentsFilter.done,
  action: Action<AssignmentsFilter>
) {
  if (action.type === actionTypes.setAssignmentsFilter) {
    return action.payload;
  }
  return state;
}
